import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing }) => ({
  filterTypeControl: {
    marginLeft: spacing(2)
  },
  filterTypelabelOutlined: {
    transform: 'translate(14px, 10px) scale(1)'
  },
  filterTypeSelect: {
    display: 'flex',
    alignItems: 'center',
    width: 170
  }
}))
